import React, { Fragment, useEffect, useState } from 'react';
import { tabbable } from 'tabbable';
import { Button, Divider } from '@nackle/origami';
import { LocaleString, getString } from '@nackle/intl-tools';
import { Gift, LinkExternal, Store } from '@nackle/origami-icons';

import './rewards-popover.less';

export const RewardsPopover = ( {
    giftCodes,
    locale,
    menuItems,
    marketplaceUrl,
    points,
    giftCodeUrl,
    closePopovers
} ) => {
    const merch = menuItems.find( item => item.pageType == 'merchandise' );
    const exp = menuItems.find( item => item.pageType == 'experiences' );
    const mastery = menuItems.find( item => item.pageType == 'mastery' );
    const gifts = giftCodes.filter( g => g.status == 'Issued' || g.status == 'Reissued' );
    const [ focusable, setFocusable ] = useState();
    const handleBlur = e => e.target === focusable[ focusable.length - 1 ] ? closePopovers() : false;

    useEffect( () => {
        setFocusable( tabbable( document.querySelector( '.rewards-popover-container' ) ) );
    }, [] );

    return <div className="rewards-popover-container" onBlur={ handleBlur } >
            <div className="rewards-popover-section rewards-section">
                { gifts.length > 0
                    ? <div className="rewards-header">
                        <span className="anticon nkl-deck-icon"><Gift className="reward-gift-icon deck-primary-color" /></span>
                        <span className="gift-code-callout-header"><LocaleString code="deck.rewardsPopover.RewardsTitle" /></span>
                    </div>
                    : null
                }
                { gifts.length > 0 && gifts.map( ( gift, index ) => {
                    return <Fragment key={ gift.giftCodeId }>
                        <div className="gift-code-callout-reward">
                            { index == 0 && <div className="congrats-header">{ getString( 'deck.rewardsPopover.hasGiftCodeTitle' ) }</div> }

                            <div className="gift-code-text">
                                { ' ' }
                                <LocaleString
                                    code="deck.rewardsPopover.hasGiftCode"
                                    replaceOptions={ { levelName: gift.description || '' } } />
                            </div>
                            <Button
                                shape="round"
                                size="small"
                                type="primary"
                                onClick={ closePopovers }
                                className="deck-redeem-btn deck-primary-background"
                                href={ `${ giftCodeUrl }/${ gift.giftCodeId }` }>
                                <LocaleString code="deck.rewardsPopover.redeemNow" />
                            </Button>
                        </div>
                    </Fragment>;
                } ) }

                { gifts.length > 0 ? <Divider /> : null }
                {
                    ( merch || exp || mastery ) &&
                    <div className={ `nkl-account-display${ !gifts || gifts.length === 0 ? ' nkl-account-no-gift-codes' : '' }` }>
                        <div className={ gifts.length > 0 ? 'rewards-header display-mobile' : 'rewards-header' }>
                            <span className="anticon nkl-deck-icon"><Store className="reward-gift-icon deck-primary-color" /></span>
                            <span className="gift-code-callout-header"><LocaleString code="deck.rewardsPopover.marketplace" /></span>
                        </div>
                        { points !== null && points >= 0 &&
                            <>
                                <div className="balance"><LocaleString code="deck.menu.myBalance" /></div>
                                <div className="nkl-points-display">
                                    <span className="points-amount">{ points.toLocaleString( locale ) }</span><span className="points-label">{ getString( 'mediaLabel' ) }</span>
                                </div>
                            </>
                        }
                    </div>
                }
            </div>

        { ( merch || exp || mastery ) &&
            <div className="rewards-popover-section redeem-section">
                <ul className="redeem-menu">
                    { merch &&
                        <li className="redeem-option">
                            <a href={ `${ marketplaceUrl }/merchandise?source=deck` } className="market-link" target="_blank" rel="noreferrer">
                                <span className="link-label" onClick={ closePopovers }>
                                    <img src={ merch.colorLogo } alt="" />
                                    <div className="rewards-store-description">
                                        <LocaleString code="deck.rewardsPopover.merchandiseLink" className="link-text" />
                                        <span className="sub-text"><LocaleString code="deck.redeem.merchDescription" /></span>
                                    </div>
                                    <span className="deck-external-link-icon">
                                        <LinkExternal />
                                    </span>
                                </span>
                            </a>
                        </li>
                    }

                    { exp &&
                        <li className="redeem-option">
                            <a href={ `${ marketplaceUrl }/experiences?source=deck` } className="market-link" target="_blank" rel="noreferrer">
                                <span className="link-label" onClick={ closePopovers }>
                                    <img src={ exp.colorLogo } alt="" />
                                    <div className="rewards-store-description">
                                        <LocaleString code="deck.rewardsPopover.experiencesLink" className="link-text" />
                                        <span className="sub-text"><LocaleString code="deck.redeem.experiencesDescription" /></span>
                                    </div>
                                    <span className="deck-external-link-icon">
                                        <LinkExternal />
                                    </span>
                                </span>
                            </a>
                        </li>
                    }
                    { mastery &&
                        <li className="redeem-option">
                            <a href={ `${ marketplaceUrl }/mastery?source=deck` } className="market-link" target="_blank" rel="noreferrer">
                                <span className="link-label" onClick={ closePopovers }>
                                    <img src={ mastery.colorLogo } alt="" />
                                    <div className="rewards-store-description">
                                        <LocaleString code="deck.rewardsPopover.masteryLink" className="link-text" />
                                        <span className="sub-text"><LocaleString code="deck.redeem.masteryDescription" /></span>
                                    </div>
                                    <span className="deck-external-link-icon">
                                        <LinkExternal />
                                    </span>
                                </span>
                            </a>
                        </li>
                    }
                </ul>
            </div>
        }
    </div>;
};

export default RewardsPopover;
